<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="exportPDF"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="exportCSV"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="mb-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#add_policy"
              class="btn btn-primary d-flex align-items-center"
              @click="openAddModal"
              v-can="'Policy.Create'"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Policy
            </a>
          </div>
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Policy list -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Policies List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input
                  type="text"
                  class="form-control date-range bookingrange"
                  ref="dateRangeInput"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy"
                />
                <span class="input-icon-addon">
                  <i class="ti ti-chevron-down"></i>
                </span>
              </div>
            </div>

            <!-- Department filter -->
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ selectedDepartmentLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setDepartment(null)"
                  >
                    All Department
                  </a>
                </li>
                <li v-for="dept in departments" :key="dept.id">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setDepartment(dept.id)"
                  >
                    {{ dept.name }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- Sort -->
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : {{ sortLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setSort('recent')"
                  >
                    Recently Added
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setSort('name_asc')"
                  >
                    Ascending
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setSort('name_desc')"
                  >
                    Descending
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="quickRange('last_month')"
                  >
                    Last Month
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="quickRange('last_7_days')"
                  >
                    Last 7 Days
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              :columns="columns"
              :data-source="tableData"
              :row-selection="rowSelection"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'Name'">
                  <h6 class="fs-14 fw-medium text-gray-9">
                    <a
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#view_policy"
                      @click.stop="viewPolicy(record)"
                      v-can="'Policy.Read'"
                    >
                      {{ record.Name }}
                    </a>
                  </h6>
                </template>

                <template v-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#view_policy"
                      class="me-2"
                      @click.stop="viewPolicy(record)"
                      v-can="'Policy.Read'"
                    >
                      <i class="ti ti-eye"></i>
                    </a>
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#add_policy"
                      @click.stop="openEditModal(record)"
                      v-can="'Policy.Edit'"
                    >
                      <i class="ti ti-edit"></i>
                    </a>
                    <a
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_modal"
                      @click.stop="openDeleteModal(record)"
                      v-can="'Policy.Delete'"
                    >
                      <i class="ti ti-trash"></i>
                    </a>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /Policy list -->
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>

  <PolicyModal
    :policy="modalPolicy"
    :policyToDelete="policyToDelete"
    @refresh="fetchPolicies"
  />

  <PolicyDetailsModal :policy="viewPolicyData" />

</template>

<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref, computed, onMounted } from "vue";
import { storeToRefs } from "pinia";
import moment from "moment";
import DateRangePicker from "daterangepicker";

import { usePolicyStore } from "@/stores/policyStore";
import { useDepartmentStore } from "@/stores/departmentStore";
import PolicyModal from "@/components/modal/policy-modal.vue";
import PolicyDetailsModal from "@/components/modal/policy-details-modal.vue";
import { toast } from "@/utils/toast";

const title = ref("Policies");
const text = ref("Employees");
const text1 = ref("Policies");




// Table columns (same UI as original)
const columns = [
  {
    sorter: false,
  },
  {
    title: "Name",
    dataIndex: "Name",
    key: "Name",
    sorter: {
      compare: (a, b) => {
        a = a.Name.toLowerCase();
        b = b.Name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Department",
    dataIndex: "Department",
    sorter: {
      compare: (a, b) => {
        a = a.Department.toLowerCase();
        b = b.Department.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Description",
    dataIndex: "Description",
    sorter: {
      compare: (a, b) => {
        a = a.Description.toLowerCase();
        b = b.Description.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Created Date",
    dataIndex: "CreatedDate",
    sorter: {
      compare: (a, b) => {
        a = a.CreatedDate.toLowerCase();
        b = b.CreatedDate.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "",
    key: "action",
    sorter: true,
  },
];

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

// Stores
const policyStore = usePolicyStore();
const departmentStore = useDepartmentStore();

const { policies } = storeToRefs(policyStore);
const { departments } = storeToRefs(departmentStore);

// Filters
const filter = ref({
  departmentId: null,
  dateFrom: null,
  dateTo: null,
  sort: "recent",
});

const dateRangeInput = ref(null);
const dateRangePicked = ref(false);

// Fetch data
function fetchPolicies() {
  policyStore.fetchPolicies();
}

onMounted(() => {
  fetchPolicies();
  if (!departments.value.length) {
    departmentStore.fetchDepartments();
  }

  if (dateRangeInput.value) {
    function booking_range(start, end) {
      return start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
    }

    new DateRangePicker(
      dateRangeInput.value,
      {
        autoUpdateInput: false,
        locale: { cancelLabel: "Clear" },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      },
      (start, end) => {
        filter.value.dateFrom = start.startOf("day").toDate();
        filter.value.dateTo = end.endOf("day").toDate();
        dateRangePicked.value = true;
        if (dateRangeInput.value) {
          dateRangeInput.value.value = booking_range(start, end);
        }
      }
    );
  }
});

// Filter helpers
const selectedDepartmentLabel = computed(() => {
  if (!filter.value.departmentId) return "Department";
  const d = departments.value.find((x) => x.id === filter.value.departmentId);
  return d ? d.name : "Department";
});

const sortLabel = computed(() => {
  switch (filter.value.sort) {
    case "name_asc":
      return "Ascending";
    case "name_desc":
      return "Descending";
    default:
      return "Recently Added";
  }
});

function setDepartment(id) {
  filter.value.departmentId = id;
}

function setSort(s) {
  filter.value.sort = s;
}

function quickRange(type) {
  const now = moment();
  if (type === "last_month") {
    const start = moment().subtract(1, "month").startOf("month");
    const end = moment().subtract(1, "month").endOf("month");
    filter.value.dateFrom = start.toDate();
    filter.value.dateTo = end.toDate();
  } else if (type === "last_7_days") {
    const start = moment().subtract(6, "days");
    const end = now;
    filter.value.dateFrom = start.toDate();
    filter.value.dateTo = end.toDate();
  }
  dateRangePicked.value = true;
}

function formatDateParam(value) {
  if (!value) return "";
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
}

// Filtered policies
const filteredPolicies = computed(() => {
  let rows = [...(policies.value || [])];

  if (filter.value.departmentId) {
    rows = rows.filter(
      (p) => Number(p.department_id) === Number(filter.value.departmentId)
    );
  }

  if (dateRangePicked.value && filter.value.dateFrom && filter.value.dateTo) {
    const from = filter.value.dateFrom.getTime();
    const to = filter.value.dateTo.getTime();
    rows = rows.filter((p) => {
      const ts = p.created_at ? new Date(p.created_at).getTime() : null;
      return ts ? ts >= from && ts <= to : true;
    });
  }

  switch (filter.value.sort) {
    case "name_asc":
      rows.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
      break;
    case "name_desc":
      rows.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
      break;
    default:
      rows.sort(
        (a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0)
      );
  }

  return rows;
});

// Table mapping
const tableData = computed(() =>
  filteredPolicies.value.map((p) => ({
    _raw: p,
    key: p.id,
    Name: p.name,
    Department: p.department?.name || "All Department",
    Description: p.description || "",
    CreatedDate: p.created_at
      ? new Date(p.created_at).toLocaleDateString()
      : "",
    fileUrl: p.file_url,
  }))
);

// Header collapse
function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

// Modal state
const modalPolicy = ref(null);
const policyToDelete = ref(null);
const viewPolicyData = ref(null);


function viewPolicy(record) {
  // record._raw is the original policy object
  const raw = record._raw;
  if (!raw) {
    toast("Unable to load policy details.", "error");
    return;
  }
  viewPolicyData.value = raw;
}


function openAddModal() {
  modalPolicy.value = null;
}



function openEditModal(record) {
  modalPolicy.value = record._raw;
}

function openDeleteModal(record) {
  policyToDelete.value = record._raw;
}

// // View policy (open file)
// function viewPolicy(record) {
//   const url = record._raw?.file_url;
//   if (url) {
//     window.open(url, "_blank");
//   } else {
//     toast("No file uploaded for this policy.", "info");
//   }
// }

// EXPORTS
function exportCSV() {
  policyStore.downloadReport("xlsx", buildExportParams());
}

function exportPDF() {
  policyStore.downloadReport("pdf", buildExportParams());
}

function buildExportParams() {
  return {
    department_id: filter.value.departmentId || "",
    date_from: formatDateParam(filter.value.dateFrom),
    date_to: formatDateParam(filter.value.dateTo),
    sort: filter.value.sort || "recent",
  };
}
</script>


